import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import $ from 'jquery';
// import Popper from 'popper.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Benign ResizeObserver noise — kept in the bundle (script-src 'self'), not an inline
// <script> in index.html, so CSP does not need a script hash for this.
const isResizeObserverLoopError = (message = '') =>
  String(message).includes('ResizeObserver loop completed with undelivered notifications') ||
  String(message).includes('ResizeObserver loop limit exceeded');

window.addEventListener('error', (event) => {
  if (isResizeObserverLoopError(event?.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
